import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { News } from '../../entities/news.model';
import { Image } from '../../entities/image.model';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms/src/model';
import { ApiService } from '../../shared/services/api.service';
import { Branch, Marketplace } from '../../entities';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CompressImageService} from '../../shared/services/compress-image.service';
import slugify from 'slugify';
import {Principal} from '../../shared';
import { JhiLanguageService } from 'ng-jhipster';
import { CUSTOM_SLUG } from '../../app.constants';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss']
})
export class NewsDetailsComponent implements OnInit, OnChanges {
  @ViewChild('ConfirmDeleteModal') deleteModal;
  @Input() data: News;
  _data: News;
  @Input() newsGroup: 'global' | 'branch' | 'commune' | 'market' | 'overview';
  @Input() marketplace: Marketplace;
  @Input() branch: Branch;
  @Input() commune: string;
  @Input() new: boolean;
  @Output() back = new EventEmitter<{ back ?, reload ? }>(true);

  public imgUrl: SafeUrl;
  public imgTooBig = false;
  public loading = false;
  public disabled = false;
  public disabledMsg: string;

  private readonly date = new Date();
  public readonly today = {
    year: this.date.getFullYear(),
    month: this.date.getMonth() + 1,
    day: this.date.getDate()
  };

  newsForm: FormGroup;
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],        // toggled buttons

      // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      // [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      // [{ 'direction': 'rtl' }],                         // text direction

      // [{ 'size': ['small', false, 'large', 'huge'] }],    // text size
      // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      // [{ 'color': [] }, { 'background': [] }],        // dropdown with defaults from theme
      // [{ 'font': [] }],
      // [{ 'align': [] }],

      ['link'],                                          // link
      ['clean'],                                         // remove formatting button
    ]
  };
  imgRemoveButtontext = '&#10060;';
  includeImage = true;

  constructor(
    public modalService: NgbModal,
    private fb: FormBuilder,
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private compression: CompressImageService,
    private langService: JhiLanguageService,
    private principal: Principal
  ) {
    this.langService.setLocations(['news']);
  }

  ngOnInit() {
    this.init().then();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Input data has changed. We need to re-initialize the component
    if (changes.data) {
     this.loading = true;
     this.init().then(() => {
       this.loading = false;
     });
    }
  }

  async init() {
    if (this.new) {
      this.data = new News({id: null, title: '', text: '', publishFromDate: new Date(), active: false,
        image: new Image().deserialize({url: ''})});
      this.data.publishFromDate = new Date().toString();
      this.data.publishUntilDate = new Date('2099-12-31 23:59:59').toString();
    } else {
      this.data = new News(this.data);
    }
    if (!this.data.image) { this.data.image = new Image(); }
    this._data = JSON.parse(JSON.stringify(this.data));
    this.imgUrl = this.sanitizer.bypassSecurityTrustUrl(this.data.image.url);
    await this.initForm();
  }

  /**
   * Initializes the form group
   */
  async initForm() {
    const now = new Date(this.data.publishFromDate);
    let fromDate;
    if (now) {
      fromDate = {day: now.getDate(), month: now.getMonth() + 1, year: now.getFullYear()};
    }
    const until = new Date(this.data.publishUntilDate);
    let toDate;
    if (until) {
      toDate = {day: until.getDate(), month: until.getMonth() + 1, year: until.getFullYear()};
    }

    this.newsForm = this.fb.group({
      title: [this.data.title, Validators.required],
      text: [this.data.text, Validators.required],
      // imageAlt: [this.data.image.alt],
      active: [this.data.active],
      publishFromDate: [fromDate],
      publishUntilDate: [toDate]
    });

    const identity = await this.principal.identity();
    if (this.data.type === 'global' && identity.contact.branches !== '01 - Geschäftsführung') {
      this.newsForm.disable();
      this.disabled = true;
      this.disabledMsg = 'Sie sind nicht berechtigt, diesen Beitrag zu verändern. ' +
        'Bei Fragen kontaktieren Sie bitte die Geschäftsführung oder den Administrator';
    }
  }

  /**
   * Updates the article image based on the selected file
   */
  onImageChange(files: FileList) {
    if (files.length === 0 || files[0].type.match(/image\/*/) == null) {
      return;
    }

    this.compression.compress(files[0]).subscribe((result) => {
      const reader = new FileReader();
      reader.readAsDataURL(result);
      reader.onload = () => {
        console.log('Compressed file size: ' + result.size / 1024 / 1024 + ' MiB');
        this.data.image = new Image().deserialize({data: reader.result});
        this.imgUrl = this.sanitizer.bypassSecurityTrustUrl(reader.result);
        // this.newsForm.get('imageAlt').setValue('');
        this.includeImage = true;

        const btn = document.getElementById('imageButton');
        if (btn) { btn.innerHTML = '&#10060;'; }
        const img = document.getElementById('image');
        if (img) { img.style.filter = null; }
      };
    });
  }

  /**
   * Processes the form data & sends them to the api, if form is valid
   */
  onSubmit() {
    // if (this.newsForm.invalid) { return; }
    const data = JSON.parse(JSON.stringify(this.data));

    Object.keys(this.newsForm.controls).forEach((key) => {
      // if (this.newsForm.get(key).dirty) {
        switch (key) {
          case 'imageUrl': break;
          case 'imageAlt': break;
          case 'publishFromDate':
            data[key] = this.dateToApiString(this.newsForm.get(key).value, '00:00:00');
            break;
          case 'publishUntilDate':
            data[key] = this.dateToApiString(this.newsForm.get(key).value, '23:59:59');
            break;
          default: data[key] = this.newsForm.get(key).value; break;
        }
      // }
    });

    /*if (this.newsForm.get('imageUrl').value !== data.image.url) {
      data['image'].alt = this.newsForm.get('imageAlt').value;
    }*/
    if (!this.includeImage || (data.image.url === '' && !data.image.data)) {
      data.image = null;
    }

    delete data.publishFromDateIso;
    delete data.publishUntilDateIso;
    delete data.createdAtIso;
    delete data.updatedAtIso;

    if (this.new) {
      slugify.extend(CUSTOM_SLUG);
      data.type = this.newsGroup;
      switch (this.newsGroup) {
        case 'branch':
          data.identifier = this.branch.id;
          break;
        case 'commune':
          data.identifier = slugify(this.commune, {lower: true});
          break;
        case 'market':
          data.identifier = this.marketplace.id;
          break;
        default:
        case 'global':
          data.identifier = null;
          break;
      }
      this.sendNew(data);
    } else {
      this.sendUpdate(data);
    }
  }

  onDelete() {
    this.modalService.open(this.deleteModal, {size: 'sm'});
  }

  /**
   * Update an existing news article
   */
  sendUpdate(data: any) {
    this.newsForm.disable();
    this.loading = true;
    let url;
    switch (this.newsGroup) {
      case 'global':
        url = 'backoffice/global/news/' + this.data.id;
        break;
      case 'branch':
        url = 'backoffice/branches/' + this.branch.id + '/news/' + this.data.id;
        break;
      case 'commune':
        slugify.extend(CUSTOM_SLUG);
        url = 'backoffice/communes/' + slugify(this.commune, {lower: true}) + '/news/' + this.data.id;
        break;
      case 'market':
        url = 'backoffice/marketplaces/' + this.marketplace.id + '/news/' + this.data.id;
        break;
      case 'overview':
        switch (this.data.type) {
          case 'global':
            url = 'backoffice/global/news/' + this.data.id;
            break;
          case 'branch':
            url = 'backoffice/branches/' + this.data.identifier + '/news/' + this.data.id;
            break;
          case 'commune':
            url = 'backoffice/communes/' + this.data.identifier + '/news/' + this.data.id;
            break;
          case 'market':
            url = 'backoffice/marketplaces/' + this.data.identifier + '/news/' + this.data.id;
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
    this.apiService.putRegular(data, url).subscribe({
      next: (res) => {
        this.newsForm.enable();
        this.loading = false;
        this.back.next({back: true, reload: true});
      },
      error: (err) => {
        this.newsForm.enable();
        this.loading = false;
        console.log(err);
        if (err.status === 413) { this.imgTooBig = true; }
      }
    });
  }

  /**
   * Create an new news article
   */
  sendNew(data: any) {
    this.newsForm.disable();
    this.loading = true;
    let url;
    switch (this.newsGroup) {
      case 'overview':
      case 'global':
        url = 'backoffice/global/news';
        break;
      case 'branch':
        url = 'backoffice/branches/' + this.branch.id + '/news';
        break;
      case 'commune':
        slugify.extend(CUSTOM_SLUG);
        url = 'backoffice/communes/' + slugify(this.commune, {lower: true}) + '/news';
        break;
      case 'market':
        url = 'backoffice/marketplaces/' + this.marketplace.id + '/news';
        break;
      default:
        break;
    }

    this.apiService.postRegular(data, url).subscribe({
      next: (res) => {
        this.newsForm.enable();
        this.loading = false;
        this.back.next({back: true, reload: true});
      },
      error: (err) => {
        this.newsForm.enable();
        this.loading = false;
      }
    });
  }

  sendDelete() {
    let url;
    switch (this.newsGroup) {
      case 'global':
        url = 'backoffice/global/news/' + this.data.id;
        break;
      case 'branch':
        url = 'backoffice/branches/' + this.branch.id + '/news/' + this.data.id;
        break;
      case 'commune':
        slugify.extend(CUSTOM_SLUG);
        url = 'backoffice/communes/' + slugify(this.commune, {lower: true}) + '/news/' + this.data.id;
        break;
      case 'market':
        url = 'backoffice/marketplaces/' + this.marketplace.id + '/news/' + this.data.id;
        break;
      case 'overview':
        switch (this.data.type) {
          case 'global':
            url = 'backoffice/global/news/' + this.data.id;
            break;
          case 'branch':
            url = 'backoffice/branches/' + this.data.identifier + '/news/' + this.data.id;
            break;
          case 'commune':
            url = 'backoffice/communes/' + this.data.identifier + '/news/' + this.data.id;
            break;
          case 'market':
            url = 'backoffice/marketplaces/' + this.data.identifier + '/news/' + this.data.id;
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
    this.apiService.delete(url)
      .subscribe((res) => {
        this.back.next({back: true, reload: true});
      });
  }

  convertDatepickerToDate(data: {day: number, month: number, year: number}) {
    if (!data) { return null; }
    return new Date(data.year + '-' + data.month + '-' + data.day);
  }

  dateToApiString(d: {day: number, month: number, year: number}, time: string = '00:00:00') {
    return d.month.toString().padStart(2, '0') + '/' + d.day.toString().padStart(2, '0') + '/' + d.year + ' ' + time;
  }

  /**
   * Check if a form control with the given name is touched & invalid
   */
  isInvalid(key: string) {
    return this.newsForm.get(key).invalid && this.newsForm.get(key).touched;
  }

  canSubmit(): boolean {
    return (
      (this.newsForm.dirty ||
        (this.data.image && this._data.image.url !== this.data.image.url) ||
        (this.data.image && this.data.image.data) ||
        !this.includeImage) &&
      (this.newsForm.controls.publishFromDate.dirty
        ? this.newsForm.controls.publishFromDate.valid
        : true) &&
      (this.newsForm.controls.publishUntilDate.dirty
        ? this.newsForm.controls.publishUntilDate.valid
        : true) &&
      !this.loading
    ); // && this.newsForm.valid;
  }

  toggleImage() {
    const btn = document.getElementById('imageButton');
    const img = document.getElementById('image');
    if (this.includeImage) {
      img.style.filter = 'grayscale(1)';
      btn.innerHTML = '&#10004;';
      this.includeImage = false;
    } else {
      img.style.filter = null;
      btn.innerHTML = '&#10060;';
      this.includeImage = true;
    }
  }

  getImageUrl(): string {
    if (this.data.image.data) {
      return this.data.image.data;
    }
    return this.data.image.url;
  }

}



// WEBPACK FOOTER //
// ./src/app/news/news-details/news-details.component.ts